import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "树操作", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("展开全部")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("收起全部")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部勾选")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消全选")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ant_icon = _resolveComponent("ant-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createBlock(_component_a_dropdown, null, {
    overlay: _withCtx(() => [
      _createVNode(_component_a_menu, { onClick: _ctx.onClick }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu_item, { key: "UNFOLD_ALL" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_item, { key: "FOLD_ALL" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          (_ctx.selectable)
            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "CHECK_ALL" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.selectable)
            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "UNCHECK_ALL" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_button, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ant_icon, { type: "DownOutlined" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}